// src/client/App.tsx
//
// Phase B T2a: providers chain (QueryClient + AuthProvider + Router).
// T2b 以降で各 page / mutation / fetcher を順次追加。

import { Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "./lib/query-client";
import { AuthProvider } from "./providers/AuthProvider";
import { router } from "./router";
import { RouteFallback } from "./components/RouteFallback";

export default function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* AppShell を通らない route group (/m・/print・/liff) の lazy chunk 読み込み中も空白にしない */}
        <Suspense fallback={<RouteFallback />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </QueryClientProvider>
  );
}
